import React from 'react';
import { NavLink } from 'react-router-dom';

import './styles.css';

const NavDropdownSubmenu = props => {
  const { items, onClick } = props;

  const handleClick = (e, item) => {
    onClick(e, item);
  };

  return (
    <ul className="navbar-dropdown__submenu-list">
      {items.map(
        (item, index) =>
          item.visible && (
            <li className="navbar-dropdown__submenu-item" key={index}>
              <NavLink
                exact
                to={item.disabled || item.onClickHandler ? '#' : item.href}
                className="navbar-dropdown__submenu-link"
                activeClassName={
                  item.disabled || item.onClickHandler
                    ? ''
                    : 'navbar-dropdown__submenu-link--selected'
                }
                onClick={e => handleClick(e, item)}
              >
                {item.name}
              </NavLink>
            </li>
          )
      )}
    </ul>
  );
};

export default NavDropdownSubmenu;
